import cc from 'classcat';
import React, { CSSProperties, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { cssUrl } from 'utils/css';
import { useUserProfile } from '../../atoms/user-profile';
import C from './SpaceCard.css';
import NounGroupIcon from '!!react-svg-loader!../welcome-page/noun-group.svg';
import { useSpaceSummary } from 'atoms/spaces';
import { humanizeDate } from 'utils/date';
import blocksBkgUrl from '../new-space-modal/icon--cocospace-light.svg';
import { qualifiedUserName } from 'utils/user';
import FlexRow from 'components/flex/FlexRow';
import { CommunityIcon } from '../min-sidebar-community-list/MinSidebarCommunityList';
import { useCommunitySummary } from 'atoms/community-summaries';
import SpaceActionsMenu from './SpaceActionsMenu';
import SpaceBookmarkControl from './SpaceBookmarkControl';
import SpaceRecencyTag from './SpaceRecencyTag';
import { Box, Chip, Tooltip } from '@mui/material';
import SpaceParticipantOverview from 'components/space-participant-overview/SpaceParticipantOverview';
import { Space } from '@cocoplatform/coco-rtc-shared';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { WorldCorridorParticipantOverview } from 'components/jam-card/JamCard';

// function generateSpaceCountMessage(
//   participantCount: number | null | undefined,
// ) {
//   if (!participantCount) {
//     return 'No one has joined this space yet';
//   } else if (participantCount == 1) {
//     return '1 member has a project in this space';
//   } else {
//     return `${participantCount} members have projects in this space`;
//   }
// }

// function generateShortUsername(
//   user: {
//     firstName?: string | null;
//     username?: string | null;
//     userId?: string | null;
//   },
//   selfUserId: string,
// ) {
//   if (user.userId == selfUserId) {
//     return 'You';
//   } else if (user.firstName) {
//     return user.firstName;
//   } else {
//     return user.username;
//   }
// }

function isRecentlyInvited(space: Space, userId: string) {
  return (
    space.isCollaborator &&
    !space.didParticipate &&
    space.createdAt &&
    space.createdAt > Date.now() - 1000 * 60 * 60 * 24 * 3 &&
    !space.hosts?.find((h) => h.id === userId)
  );
}

export default function SpaceCard(p: {
  spaceId: string;
  style?: CSSProperties;
  arrow?: boolean;
  containerWidth: number;
  previewHeight: number;
  showCommunityIcon?: boolean;
  showHostLabel?: boolean;
  showRecencyTag?: boolean;
  showDateTag?: boolean;
  selected?: boolean;
  onClick?: () => void;
}) {
  const { _ } = useLingui();
  const { space } = useSpaceSummary({
    spaceId: p.spaceId,
  });

  const { userProfile } = useUserProfile();
  const selfHostIdx =
    userProfile &&
    space?.hosts?.findIndex((user) => {
      return user.id === userProfile?.id;
    });
  const isSelfHosted = selfHostIdx != null && selfHostIdx >= 0;
  const showHostLabel = isSelfHosted && p.showHostLabel !== false;
  const showCommunityIcon = p.showCommunityIcon !== false;
  const history = useHistory();
  const participantCount = space?.participantCount;

  // Render:
  if (!space) return null;
  return (
    <div
      className={C.cardContainer}
      data-space-id={space.id}
      style={{
        ...p.style,
        border: p.selected ? '2px solid var(--color-primary)' : undefined,
        flexBasis: p.containerWidth + 'px',
      }}
    >
      <div
        className={cc({
          [C.cardPreview]: true,
          [C.defaultBkg]: !space.bannerUrl,
        })}
        style={{
          backgroundImage: cssUrl(
            space.bannerUrl ??
              (space.thumbnail ? '/' + space.thumbnail : undefined) ??
              blocksBkgUrl,
          ),
          height: p.previewHeight + 'px',
          flexBasis: p.previewHeight + 'px',
          cursor: 'pointer',
          backgroundColor: space.bannerUrl ? 'var(--color-base)' : undefined,
        }}
        onClick={
          p.onClick ??
          ((e) => {
            history.push(
              `/app/dashboard/${space.communityId || '$all'}/spaces/${space.id}`,
            );
          })
        }
      >
        <SpaceBookmarkControl spaceId={p.spaceId} isSelfHosted={isSelfHosted} />
        {p.showDateTag && (
          <div className={C.startDate}>
            {humanizeDate(space.startedAt ?? space.expectedToStartAt, {
              prefixAt: false,
            })}
          </div>
        )}
        {userProfile &&
          isRecentlyInvited(space, userProfile?.id) &&
          space.hosts?.[0] && (
            <SpaceRecencyTag
              msg={_(
                msg`Invited by ${space.hosts[0].username || space.hosts[0].firstName}`,
              )}
            />
          )}
        {showCommunityIcon && (
          <div className={C.communityIconContainer}>
            <CommunityIcon
              isActive={false}
              name={space.community?.name}
              className={C.communityIcon}
              avatarUrl={space.community?.avatarUrl}
              id={space.community?.id}
            />
          </div>
        )}
      </div>
      <div className={C.cardDetails}>
        <FlexRow>
          <div
            className={C.spaceTitle}
            title={space.title ?? undefined}
            onClick={() => {
              const spacePath = `/app/dashboard/${space.communityId}/spaces/${space.id}`;
              history.push(spacePath);
            }}
          >
            {space.title}
          </div>
          <SpaceActionsMenu
            spaceId={p.spaceId}
            style={{ color: 'var(--color-subtext)' }}
          />
        </FlexRow>
        {space.communityId ? (
          <SpaceParticipantOverview spaceId={space.id} />
        ) : (
          <WorldCorridorParticipantOverview spaceId={space.id} />
        )}
      </div>
    </div>
  );
}
